import { PaginatedRequestParams } from 'api';
import { MainFiltersParams } from 'components/main-filters/main-filters';

export enum ExpensesFilterFormField {
  FacilityName = 'FacilityId',
  FieldName = 'FieldId',
  SportName = 'SportsId',
}

export type ExpensesFilterFormValues = {
  [ExpensesFilterFormField.FieldName]: string | undefined;
  [ExpensesFilterFormField.FacilityName]: string | undefined;
  [ExpensesFilterFormField.SportName]: string | undefined;
};

export type ExpensesFilterFormPaginated = ExpensesFilterFormValues &
  MainFiltersParams &
  PaginatedRequestParams;
